import { Link } from 'react-router-dom'
import { LayoutDashboard, List, Grid } from 'lucide-react'

export default function HomePage() {
  return (
    <div className="max-w-7xl mx-auto p-8">
      <div className="mb-8">
        <h1 className="text-4xl font-bold text-text-primary mb-2">
          Welcome to TaxHive
        </h1>
        <p className="text-lg text-text-secondary">
          A comprehensive platform for Chartered Accountants to manage customers, tax filings, GST returns, and financial documentation
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Link
          to="/dashboard"
          className="card card-elevated hover:scale-105 transition-transform p-6"
        >
          <LayoutDashboard className="w-12 h-12 text-primary-500 mb-4" />
          <h3 className="text-xl font-semibold text-text-primary mb-2">Dashboard</h3>
          <p className="text-text-secondary">
            View customer analytics, filing statistics, and key metrics at a glance
          </p>
        </Link>

        <Link
          to="/customers"
          className="card card-elevated hover:scale-105 transition-transform p-6"
        >
          <List className="w-12 h-12 text-primary-500 mb-4" />
          <h3 className="text-xl font-semibold text-text-primary mb-2">Customers</h3>
          <p className="text-text-secondary">
            Manage your customers, track tax assessments, and financial documents
          </p>
        </Link>

        <Link
          to="/search"
          className="card card-elevated hover:scale-105 transition-transform p-6"
        >
          <Grid className="w-12 h-12 text-primary-500 mb-4" />
          <h3 className="text-xl font-semibold text-text-primary mb-2">Search</h3>
          <p className="text-text-secondary">
            Quickly find customers, assessments, and documents across your practice
          </p>
        </Link>
      </div>

      <div className="mt-12 p-6 bg-surface-elevated rounded-lg border border-primary-200/20">
        <h2 className="text-2xl font-semibold text-text-primary mb-4">Getting Started</h2>
        <ul className="space-y-2 text-text-secondary">
          <li className="flex items-start">
            <span className="text-primary-500 mr-2">•</span>
            All components from <code className="text-primary-500">cml-webui-commons</code> are
            available
          </li>
          <li className="flex items-start">
            <span className="text-primary-500 mr-2">•</span>
            Authentication is pre-configured with JWT and RBAC
          </li>
          <li className="flex items-start">
            <span className="text-primary-500 mr-2">•</span>
            Dark mode and theme switching work out of the box
          </li>
          <li className="flex items-start">
            <span className="text-primary-500 mr-2">•</span>
            Track ITR filings, GST returns, TDS, and other tax obligations
          </li>
        </ul>
      </div>
    </div>
  )
}
